"use client";
import React, { useState } from "react";
import classnames from "classnames";

import {
  SideBySideMagnifier as OriginalSideBySideMagnifier,
  MagnifierPreview as OriginalMagnifierPreview,
} from "react-image-magnifiers";

const SideBySideMagnifier = (props) => <OriginalSideBySideMagnifier {...OriginalSideBySideMagnifier.defaultProps} {...props} />;

import { shouldAllowMagnification } from "@stadium/ui/src/components/image-magnifier/utils";

import defaultStyles from "./main.module.scss";

const defaultRenderCustomOverlay = (active) => {
  if (active) return null;

  return (
    <div className={defaultStyles.hintContainer}>
      <svg viewBox="0 0 24 24" width="16" height="16" fill="white">
        <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"></path>
      </svg>
    </div>
  );
};

const ImageMagnify = ({
  src = "",
  name = "",
  alt = `${name} image`,
  displayLoader = true,
  loadingClassName = "",
  onLoad,
  fillAvailableSpace = false,
  className = "",
  styles = defaultStyles,
  zoomContainerBorder = "1px solid white",
  renderCustomOverlay = defaultRenderCustomOverlay,
  zoomContainerBoxShadow = "0 4px 8px rgba(0,0,0,.5)",
  onZoomStart,
  onZoomEnd,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(displayLoader);
  const loadingClasses = isLoading ? `${styles.imageLoading} ${loadingClassName}` : "";

  const [canMagnify, setCanMagnify] = useState(false);

  const customClassName = classnames(className, loadingClasses, styles.imageContainerMagnifier, {
    [defaultStyles.disableMouseEvent]: !canMagnify,
  });

  const onImageLoad = (e) => {
    setIsLoading(false);
    onLoad?.();

    setCanMagnify(shouldAllowMagnification(e.currentTarget));
  };

  return (
    <SideBySideMagnifier
      onImageLoad={onImageLoad}
      imageAlt={alt}
      zoomContainerBorder={zoomContainerBorder}
      zoomContainerBoxShadow={zoomContainerBoxShadow}
      fillAvailableSpace={fillAvailableSpace}
      className={customClassName}
      imageSrc={src || ""}
      renderOverlay={canMagnify && renderCustomOverlay}
      {...(onZoomStart && { onZoomStart })}
      {...(onZoomEnd && { onZoomEnd })}
      {...rest}
    />
  );
};

export const MagnifierPreview = (props) => {
  const [canMagnify, setCanMagnify] = useState(false);
  return (
    <OriginalMagnifierPreview {...OriginalMagnifierPreview.defaultProps}
      {...props}
      renderOverlay={canMagnify && props.renderOverlay}
      className={classnames(props.className, { [defaultStyles.disableMouseEvent]: !canMagnify })}
      onImageLoad={(e) => {
        setCanMagnify(shouldAllowMagnification(e.currentTarget));
        props.onImageLoad?.(e);
      }}
    />
  );
};

export default ImageMagnify;
